<template>
    <purchase_order_delivery v-if="userInfo.operation_mode == 3" :tab="tab"></purchase_order_delivery>
    <order_delivery v-else :tab="tab"></order_delivery>
</template>

<script>
import order_delivery from './order_delivery.vue'
import purchase_order_delivery from './purchase_order_delivery.vue'
import {mapState} from "vuex";

export default {
    props: {
        tab: String
    },

    computed: {
        ...mapState(['userInfo', 'systemConfig']),
    },

    components: {
        order_delivery,purchase_order_delivery
    }
}
</script>